import debounce from '../../utils/debounce';
import '../../vendor/slick.js';

export const setupProductCarousel = ($: JQueryStatic) => {
  const mq = window.matchMedia('(min-width:72em)');
  function productCarousel() {
    const $productCarousel = $('.product-carousel');

    if (!mq.matches) {
      $productCarousel.slick();
    }

    if (mq.matches && $productCarousel.hasClass('slick-initialized')) {
      $productCarousel.slick('unslick');
    }
  }

  /** Functions that should run on debounce **/
  window.addEventListener('resize', debounce(productCarousel, 100));
  productCarousel();
};

export const setupHomeSlideshow = ($: JQueryStatic) => {
  $('.homeSlideshow').slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 8000,
  });
};

export const setupSlideshow = ($: JQueryStatic) => {
  $('.slideshow').slick({ lazyLoad: 'progressive' });
  $('.slick-dots').wrap("<div class='slick-dots-wrap'><div>");
};

export const setupPhotoGallery = ($: JQueryStatic) => {
  $('.photo-gallery.rotating').slick({
    dots: false,
    speed: 300,
    slidesToShow: 4,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.photo-gallery-thumbs').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.photo-thumbs',
  });

  $('.photo-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.photo-gallery-thumbs',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,

    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};
